
//stop activities been clickable or focusable if user is not logged in. 

document.addEventListener('DOMContentLoaded', function () {
    const hiddenSection = document.querySelector('.c-hidden-activities');
    if (hiddenSection) {
      const focusableSelectors = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'iframe',
        'object',
        'embed',
        '[tabindex]',
        '[contenteditable]'
      ];

      const focusableElements = hiddenSection.querySelectorAll(focusableSelectors.join(','));

      focusableElements.forEach(el => {
        // Prevent tab focus
        el.setAttribute('tabindex', '-1');
        // Optional: disable click actions too
        el.setAttribute('aria-hidden', 'true');
      });
    }
  });